import axios from "axios";
import ConstantList from "../appConfig";

const API_PATH = ConstantList.API_EN_POINT + "/sys-function";

export const pagingSysFunction = (obj) => {
    return axios.post(API_PATH + "/page",obj);
};

export const saveSysFunction = obj => {
    return axios.post(API_PATH + "/save", obj);
}

export const updateSysFunction = (id,obj) => {
    return axios.put(API_PATH + "/update/" + id, obj);
}

export const getSysFunctionById = id =>{
    const url = API_PATH + "/get-by-id/" + id;
    return axios.get(url);
}

export const deleteSysFunctionById = id =>{
    const url = API_PATH + "/delete/" + id;
    return axios.delete(url);
}